export default __webpack_public_path__ + "static/animoca-1c70ae2531848b623044543bc099440b.png";